import { Pipe, PipeTransform } from '@angular/core';
import { ProductPlanModel } from 'models/generated/Entities.GormCrm.ProductPlan';
import { CurrencyPipe } from 'pipes/currency.pipe';
import { CustomDatePipe } from 'pipes/custom-date.pipe';
import { AccountingService } from 'services/accounting.service';

@Pipe({
	name: 'productName', pure: false
}) // Pipe must be impure, because it relies on data in the object that can change while the object reference remains the same.
export class ProductNamePipe implements PipeTransform {

	constructor(
		private readonly accountingService: AccountingService,
		private readonly datePipe: CustomDatePipe,
		private readonly currencyPipe: CurrencyPipe
	) { }

	transform(plan: ProductPlanModel | null | undefined, useParentIdentification: boolean = false, displayAccountingPlanInformation: boolean = false, displayReferenceNo: boolean = true, displayAccountingPlanDates: boolean = true): string {

		if (!plan) return '';

		let productIdentification = plan.productIdentification ? plan.productIdentification : useParentIdentification ? plan.parent?.productIdentification : undefined;
		let accountingPlanInformation = '';
		let referenceNo = '';

		if (displayAccountingPlanInformation && plan.accountingPlans) {
			const currentAccountingPlan = this.accountingService.filterCurrentAccountingPlan(plan.accountingPlans);
			if (displayReferenceNo) referenceNo = `${currentAccountingPlan.referenceNo} - `;
			if (displayAccountingPlanDates && currentAccountingPlan.startDate && currentAccountingPlan.endDate)
				accountingPlanInformation = `${this.datePipe.transform(currentAccountingPlan.startDate, 'shortDate')} - ${this.datePipe.transform(currentAccountingPlan.endDate, 'shortDate')} - ${this.currencyPipe.transform(currentAccountingPlan.totalPlanValue)}`;
			else
				accountingPlanInformation = this.currencyPipe.transform(currentAccountingPlan.totalPlanValue);
		}

		const identificationText = [productIdentification, accountingPlanInformation].filter(i => i).map(i => ` (${i})`).join('');

		return `${referenceNo}${plan.productName}${identificationText}`;
	}
}
